import { Modal } from "react-bootstrap";
import { StyledModalTitle } from "../../../@ui/StyledModalTitle";
import ThemedModal from "../../../@ui/Modal/ThemedModal";

interface ParametersModalProps {
  params: string;
  onClose: () => void;
}

const ParametersModal = ({ params, onClose }: ParametersModalProps) => {
  return (
    <>
      <ThemedModal onHide={() => onClose()} centered show={params != null}>
        <Modal.Header className="bg-secondary text-white" closeButton>
          <StyledModalTitle>Request Parameters</StyledModalTitle>
        </Modal.Header>
        <Modal.Body className="overflow-auto">
          <pre>{params}</pre>
        </Modal.Body>
      </ThemedModal>
    </>
  );
};

export default ParametersModal;
